import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransferArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.854 10.5574H6.9751L8.92822 12.5105H7.82275L5.479 10.1667L7.82275 7.823H8.92822L6.9751 9.77612H14.854V10.5574Z",
		fill: "#E60023"
	})]
});
export default SvgTransferArrowLeft;
